import { FC } from 'react';
import { noop } from 'lodash';

import classNames from 'classnames';
import { IonButton, IonSpinner } from '@ionic/react';

import { CommonButtonProps } from '../Button.types';
import { BUTTON_SIZE_MAP } from '../Button.const';

import {
  BUTTON_SOCIAL_TYPE_FILL,
  BUTTON_SOCIAL_TYPE_IMAGE,
} from './ButtonSocial.const';
import { ButtonSocialVariant } from './ButtonSocial.types';

import button from '../Button.module.scss';
import styles from './ButtonSocial.module.scss';

interface ButtonSocialProps extends CommonButtonProps {
  variant: ButtonSocialVariant;
}

export const ButtonSocial: FC<ButtonSocialProps> = ({
  variant,
  loading,
  disabled,
  className,
  size = 'm',
  onClick = noop,
}) => {
  return (
    <IonButton
      type="button"
      disabled={disabled}
      className={classNames(
        button.root,
        {
          [styles.apple]: variant === 'apple',
          [styles.facebook]: variant === 'facebook',
          [styles.google]: variant === 'google',
          //   [styles.tertiary]: variant === 'tertiary',
          //   [styles.small]: size === 's',
        },
        className
      )}
      size={BUTTON_SIZE_MAP[size]}
      onClick={!loading && onClick}
      fill={BUTTON_SOCIAL_TYPE_FILL[variant]}
    >
      <span
        className={classNames(button.label, {
          [button.loading]: loading,
        })}
      >
        <img
          alt={variant}
          className={styles.img}
          src={BUTTON_SOCIAL_TYPE_IMAGE[variant]}
        />
      </span>
      {loading && <IonSpinner className={button.spinner} />}
    </IonButton>
  );
};
